import { factoryService, getJsonRequest, postJsonRequest } from '@chilecompra/react-kit/requests'
import { REACT_APP_API_BASE_OCP_URL, REACT_APP_API_BASE_SELLER_URL } from '../config/settings/environment'

/**
 * Gets the identity by the given DNI.
 */
export const getIdentity = factoryService(({ dni }) =>
  getJsonRequest(
    `${REACT_APP_API_BASE_SELLER_URL}/v1/usuario-registro/informacionPersona/${dni}?origen=inscripcion-comprador-front&validaFallecido=true`
  )
)

/**
 *
 * Mark user how to recover admin.
 */
export const recoverAdmin = factoryService(({ institucion, flow, guest, token }) => {
  const body = {
    institucion,
    flujo: flow,
    personaAdministradora: guest,
    token
  }
  return postJsonRequest(`${REACT_APP_API_BASE_OCP_URL}/v1/compradores-consumer/recuperar-administracion`, {
    body
  })
})
